import { render, staticRenderFns } from "./InputLogradouroTipo.vue?vue&type=template&id=1ac010ff&scoped=true"
import script from "./InputLogradouroTipo.vue?vue&type=script&lang=js"
export * from "./InputLogradouroTipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../paylogos-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac010ff",
  null
  
)

export default component.exports